import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { specialityType } from 'src/app/api/interfaces/configuration.interface';
import {
  IPubBuilding,
  IPubDailyQuest,
} from 'src/app/api/interfaces/pub.interface';
import { ICompletedCharacterSlots } from 'src/app/store/characterState/characterState.reducer';

@Injectable({
  providedIn: 'root',
})
export class PubService {
  public pubBuilding: BehaviorSubject<IPubBuilding | undefined> =
    new BehaviorSubject<IPubBuilding | undefined>(undefined);
  public dailyQuestsList: IPubDailyQuest[] = [];
  public pickedDailyQuestSpeciality: specialityType = '';
  public currentQuestId: string | undefined;
  public currentQuestSlotIndex: number | undefined;
  public characterInUse: number[] = [];
  constructor() {}

  public updateDailyQuestList(dailyTask: IPubDailyQuest): void {
    const oldPubValues = this.pubBuilding.getValue();
    if (dailyTask && oldPubValues) {
      const newTaskList = oldPubValues.dailyTasks.map((task) => {
        if (task.configuration.id === dailyTask.configuration.id) {
          return { ...dailyTask, configuration: { ...task.configuration } };
        } else {
          return task;
        }
      });
      console.log('old', oldPubValues, 'new', newTaskList);
      this.pubBuilding.next({ ...oldPubValues, dailyTasks: newTaskList });
    }
  }

  public createDailyQuestList(
    characterSlots: ICompletedCharacterSlots[],
    dailyTasks: IPubDailyQuest[]
  ): any {
    const completedDailyTaskList = dailyTasks
      .filter(
        (task) =>
          task.status === 'CREATED' ||
          task.status === 'IN_PROCESS' ||
          task.status === 'DONE'
      )
      .map((task) => {
        let preparedCharacterIds: any = [];
        const characterWithSpecialitySlots =
          task.configuration.required.specialities.map((taskSlot) => {
            const characterSlot = characterSlots
              .filter((slot) => slot.character)
              .find(
                (slot) =>
                  slot.character?.id ===
                  task.characterIds[taskSlot.sequenceNumber]
              );
            preparedCharacterIds.push(characterSlot?.character?.id);
            return {
              ...taskSlot,
              pickedCharacterSlot: characterSlot,
            };
          });
        const canStart = characterWithSpecialitySlots.map((slot) => {
          if (slot.pickedCharacterSlot && slot.pickedCharacterSlot?.character) {
            return task.configuration.required.specialities.map(
              (reqSpeciality) => {
                const neededCharacterSpeciality =
                  slot.pickedCharacterSlot?.character?.specialities.find(
                    (speciality) =>
                      speciality.config?.speciality === reqSpeciality.name
                  );
                if (neededCharacterSpeciality) {
                  return (
                    neededCharacterSpeciality.speciality.level >=
                    reqSpeciality.level
                  );
                } else {
                  return [false];
                }
              }
            );
          } else {
            return [false];
          }
        });

        return {
          ...task,
          characterIds: preparedCharacterIds,
          canStartTask: !canStart
            .reduce((acc, val) => acc.concat(val), [])
            .includes(false),
          configuration: {
            ...task.configuration,
            required: {
              ...task.configuration.required,
              specialities: characterWithSpecialitySlots,
            },
          },
        };
      });
    this.characterInUse = dailyTasks
      .map((task) => {
        return task.characterIds;
      })
      .reduce((acc, val) => acc.concat(val), []);
    this.dailyQuestsList = completedDailyTaskList;
    return completedDailyTaskList;
  }
}
